export default "__VITE_ASSET__60f8abc3__"